<template>
  <div>
    <vx-card>
      <h4 class="mb-5">Your Virtual Tour and Job Experience Induction</h4>
      <p class="my-5">
        Please watch the video below to get an overview of many of the aspects of the creative
        industry.
      </p>
      <p class="my-5">
        <strong
          >You must scroll down and download the Induction Sheet and read it carefully. This is
          compulsory!</strong
        >
      </p>
      <div class="vx-row mt-10 mb-5">
        <div class="vx-col xl:w-2/3 w-full mx-auto">
          <responsive-iframe-youtube :src="video.url | blob_url" :posterimg="video.image" />
        </div>
      </div>
    </vx-card>
    <vx-card>
      <vs-list>
        <vs-list-item
          title="Induction Sheet"
          subtitle="An overview of what is expected of you and the rules you must follow."
        >
          <a
            :href="'content/creativeindustries/induction_sheet.pdf' | blob_url"
            target="_blank"
            class="btn btn-primary btn-size-medium"
            >Download</a
          >
        </vs-list-item>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    video() {
      return {
        url: 'content/' + this.experience.vje.folder_name + '/virtual_tour.mp4',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name +
          '/virtual_tour.jpg'),
      };
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
